import { Injectable } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { SimpleRequestString } from '../shared/models/SimpleRequestString';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ForgotPassService {

  constructor(private httpService: HttpService) { }

  validateEmailExist(data: SimpleRequestString) {
    return this.httpService.validateEmailExist(data).pipe(
      tap((data) => {
      })
    );
  }
}
